




















































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import * as planningService from '@/services/planning-service'
import ShiftEditorStartEnd from '@/components/planning/shift/ShiftEditorStartEnd.vue'
import ShiftEditorPeriodicity from '@/components/planning/shift/ShiftEditorPeriodicity.vue'
import ShiftEditorAdditionalFields from '@/components/planning/shift/ShiftEditorAdditionalFields.vue'
import ShiftEditorEmployee from '@/components/planning/shift/ShiftEditorEmployee.vue'
import ShiftEditorWork from '@/components/planning/shift/ShiftEditorWork.vue'
import ShiftEditorTimes from '@/components/planning/shift/ShiftEditorTimes.vue'
import ShiftEditorFinish from '@/components/planning/shift/ShiftEditorFinish.vue'
import { CompanyStructure, DataPeriodicity, DataStartEnd, PeriodicityPlannedEmployee } from '@/types'
import { ShiftEditorPlanningPayload } from '@/model/planning/ShiftEditorPlanningPayload'
import {
  FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING,
  FETCH_TASK_LIST,
  PLANNING_ASSISTANT_INIT_FROM_PAYLOAD,
  PLANNING_ASSISTANT_RESET_STATE,
  PLANNING_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING,
  PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_SET_TASK_LIST,
  PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY,
  UPDATE_SHIFT_PLAN,
  FETCH_EDIT_SHIFT,
  UPDATE_SHIFT_PROJECT,
  PLANNING_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT,
  DELETE_PROJECT_SERIEN,
  PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID,
  PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID,
  PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  FETCH_CAPACITY_LIST,
  CREATE_SHIFT_NEW,
  PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST, UPDATE_AUTO_SHIFT_PLAN, FETCH_PRESELECTED_EMPLOYEE
} from '@/store/action-types'
import {
  CompanyFilterValue,
  CreateShiftPayload,
  FetchEmployeeListForPlanningPayload,
  PlanningAssistantPeriodicityPayload,
  EmployeeCapacityPayload, AdditionalFieldsPayloadItem, EditShiftNewPayload, EditShiftDetails, PlanningDetailsPayload
} from '@/types/payload'
import {
  PLANNING_ASSISTANT_GET_COMPANY_FILTER,
  PLANNING_ASSISTANT_GET_END_DATE,
  PLANNING_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_PERIODICITY,
  PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY,
  PLANNING_ASSISTANT_GET_START_DATE,
  PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING,
  PLANNING_ASSISTANT_GET_TASK_LIST,
  PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID,
  PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_IS_PROJECT,
  PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM,
  PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID,
  PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  COMPANY_GET_BASIC_COMPANY_STRUCTURE, PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS, GET_SECURITY_DATA
} from '@/store/getter-types'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import { Employee } from '@/model/companyStructure/Employee'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { Task } from '@/model/planning/Task'
import { ShiftAvailability, ActionsEnum, ViewEnum } from '@/types/enums'
import {
  AutomaticOneResponse,
  CreateShiftNewResponse,
} from '@/types/service-response'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { Address } from '@/model/planning/Address'
import { EmployeeCapacity } from '@/model/planning/EmployeeCapacity'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import { SecurityData } from '@/model/SecurityData'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'

interface ComponentData {
  dataStartEnd: DataStartEnd | undefined
  dataPeriodicity: DataPeriodicity | undefined
  dataEmployee: Object | undefined
  selectedEmployeeList: PlannedEmployee[]
  loading: boolean
  selectedAddress: Address | undefined
  selectedProject: PlanningLookupProject | null
  selectedAbo: any | null
  employeeCapacityList: Array<EmployeeCapacity>
  isEditProject: boolean
  stepper: string
  editAdditional: boolean
  editWork: boolean
  editTime: boolean
}

export default Vue.extend({
  name: 'ShiftEditor',

  components: {
    ShiftEditorStartEnd,
    ShiftEditorPeriodicity,
    ShiftEditorAdditionalFields,
    ShiftEditorEmployee,
    ShiftEditorWork,
    ShiftEditorTimes,
    ShiftEditorFinish,
    ProgressCircular
  },

  props: {
    showDialog: Boolean,

    planningPayload: {
      type: Object as () => ShiftEditorPlanningPayload
    },

    action: {
      type: String as () => ActionsEnum
    },

    employeeEventList: {
      type: Array as () => Array<EmployeeEvent>
    },

    editShift: Object as () => EditShiftPlan | undefined,

    isEdittingShift: Boolean,
    isEdittingSerie: Boolean,
    selectedDetailId: Number,
    projectId: Number,

    filteredEmployees: {
      type: Array as () => Array<Employee>
    },

    projectSerieTemplate: Object as () => ShiftTemplate | undefined,
    shiftTemplateList: Array as () => Array<ShiftTemplate>,
    editShiftAddressId: Number
  },

  data (): ComponentData {
    return {
      dataStartEnd: undefined,
      dataPeriodicity: undefined,
      dataEmployee: undefined,
      selectedEmployeeList: [],
      loading: false,
      selectedAddress: undefined,
      selectedProject: null,
      selectedAbo: null,
      employeeCapacityList: [],
      isEditProject: false,
      stepper: "1",
      editAdditional: false,
      editWork: false,
      editTime: false
    }
  },

  computed: {
    companyFilter (): CompanyFilterValue {
      return this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
    },

    initialEmployeeList (): Employee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST]
    },

    dateStart (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
    },

    companyStructure(): CompanyStructure {
      return this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]
    }
  },

  methods: {
    onStepperKeyDown (event: any) {
      if(event.code === 'Space' || event.code === 'Enter') {
        if(event.target && event.target.id) {
          this.stepper = event.target.id
        }
      } else if(event.code === 'ArrowDown' && this.stepper === '4') {
        this.editAdditional = true
      } else if(event.code === 'ArrowDown' && this.stepper === '5') {
        this.editWork = true
      } else if(event.code === 'ArrowDown' && this.stepper === '6') {
        this.editTime = true
      }
    },

    goToNextStep (step: string): void {
      this.stepper = step
      if(step === '4') {
        setTimeout(() => {
          const focusedField: any = document.getElementById('4')
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      } else if(step === '5') {
        setTimeout(() => {
          const focusedField: any = document.getElementById('5')
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      } else if(step === '6') {
        setTimeout(() => {
          const focusedField: any = document.getElementById('6')
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    async onCloseDialog (): Promise<void> {
      const projectSerieId = this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID]
      const freePeriodicityProjectSerieId = this.$store.getters[PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID]
      if (projectSerieId) {
        await this.$store.dispatch(DELETE_PROJECT_SERIEN, projectSerieId)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID, undefined)
        this.updateDataSet()
      }

      if (freePeriodicityProjectSerieId) {
        await this.$store.dispatch(DELETE_PROJECT_SERIEN, freePeriodicityProjectSerieId)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID, undefined)
        this.updateDataSet()
      }

      this.$emit('close')
    },

    onChangeDataStartEnd (data: DataStartEnd): void {
      this.dataStartEnd = data
    },

    onChangeDataPeriodicity (data: DataPeriodicity): void {
      this.dataPeriodicity = data
    },

    onChangeDataEmployeeList (data: object): void {
      this.dataEmployee = data
    },

    onSelectAddress (data: Address): void {
      this.selectedAddress = data
    },

    onSelectProject (data: PlanningLookupProject | null): void {
      this.selectedProject = data
    },

    onSelectAbo (data: any | null): void {
      this.selectedAbo = data
    },

    async fetchInitialData (): Promise<void> {
      const taskList: Task[] = await this.$store.dispatch(FETCH_TASK_LIST)

      this.$store.dispatch(PLANNING_ASSISTANT_SET_TASK_LIST, taskList)
    },

    updateDataSet () {
      this.$emit('updateDataSet')
    },

    async onSaveButtonClick (): Promise<void> {
      this.loading = true

      try {

        const autoPlanningIsProject: boolean = this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_IS_PROJECT]
        if (this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST].length > 0 && this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID] && autoPlanningIsProject) {
          // Auto planning create

          let projectId: number = this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID]
          const data: Array<EditShiftPlan> = await this.$store.dispatch(FETCH_EDIT_SHIFT, projectId)
          const foundShift: EditShiftPlan | undefined = data[0]

          const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
          const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
          const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
          const plannedEmployeeList: PlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
          const additionalFieldsPayload: AdditionalFieldsPayloadItem[] = this.$store.getters[PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS]

          let fixed: string = ''
          let provisorich: string = ''
          if (availability === ShiftAvailability.Fixed) {
            fixed = 'True'
            provisorich = 'False'
          } else {
            fixed = 'False'
            provisorich = 'True'
          }

          let shiftDetailsPayload: EditShiftDetails[] = plannedEmployeeList.map((item: PlannedEmployee, rowIdx: number) => {
            const foundDetails: any = foundShift!.details.find((i: any) => i.row === item.number)
            const details: EditShiftDetails = {
              detailID: foundDetails ? foundDetails.detailId : null,
              Zeile: rowIdx + 1,
              datumStart: item.start ? moment(item.start).format('YYYY/MM/DD HH:mm') : null,
              datumEnde: item.end ? moment(item.end).format('YYYY/MM/DD HH:mm') : null,
              MitarbeiterID: item.id ? item.id : 0,
              NotizElement: item.note ? item.note : '',
              ArbeitID: item.taskId ? item.taskId : null
            }
            return details
          })

          const editShiftPayload: EditShiftNewPayload = {
            ProjektSerieID: foundShift.projectSerieId!,
            ProjektID: foundShift.projectId,
            Schichtname: foundShift.shiftName,
            TypeOfShift: foundShift.typeOfShift ? foundShift.typeOfShift : '',
            profitcenter: foundShift.profitcenter,
            SchichtID: foundShift.shiftId,
            Abteilung: foundShift.department,
            Sachbearbeiter: foundShift.sachbearbeiter,
            ReferenzTermin: foundShift.referenzTermin,
            Montag: foundShift.monday,
            Dienstag: foundShift.tuesday,
            Mittwoch: foundShift.wednesday,
            Donnerstag: foundShift.thursday,
            Freitag: foundShift.friday,
            Samstag: foundShift.saturday,
            Sonntag: foundShift.sunday,
            Whlg: foundShift.whlg,
            Einmalig: foundShift.unique,
            EndAfternTimes: foundShift.endAfterTimes,
            EndAfterDate: foundShift.endAfterDate ?  moment(foundShift.endAfterDate).format('YYYY/MM/DD HH:mm') : null,
            provisorisch: provisorich,
            fixiert: fixed,
            datumStart: dateStart ? moment(dateStart).format('YYYY/MM/DD HH:mm') : null,
            datumEnde: dateEnd ? moment(dateEnd).format('YYYY/MM/DD HH:mm') : null,
            Adresse: foundShift.address,
            ReferenzProjektID: foundShift.referenzProjektId,
            AbonnementID: foundShift.abonnementId,
            DetailsForUpdate: shiftDetailsPayload,
            ZusatzfelderForUpdate: additionalFieldsPayload
          }

          const response = await this.$store.dispatch(UPDATE_AUTO_SHIFT_PLAN, editShiftPayload)
          if (response && !response.IsError) {

            let updatedIdList: number[] = []

            this.$emit('shiftPlanEdited', editShiftPayload.ProjektSerieID, updatedIdList)
          } else {
            this.$emit('shiftPlanEditedFalse')
          }

        } else if (this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST].length > 0 && this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID] && !autoPlanningIsProject) {
          // Auto planning period create

          let projectId: number = this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID]
          const data: Array<EditShiftPlan> = await this.$store.dispatch(FETCH_EDIT_SHIFT, projectId)
          const foundShift: EditShiftPlan | undefined = data[0]

          const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
          const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
          const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
          const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
          const periodicityPlannedEmployeeList: PeriodicityPlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
          const additionalFieldsPayload: AdditionalFieldsPayloadItem[] = this.$store.getters[PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS]

          let fixed: string = ''
          let provisorich: string = ''
          if (availability === ShiftAvailability.Fixed) {
            fixed = 'True'
            provisorich = 'False'
          } else {
            fixed = 'False'
            provisorich = 'True'
          }

          let shiftDetailsPayload: EditShiftDetails[] = []

          periodicityPlannedEmployeeList.forEach((item: PeriodicityPlannedEmployee) => {
            item.employeeList.forEach((employee: PlannedEmployee, rowIdx: number) => {
              const details: EditShiftDetails = {
                detailID: employee.detailID!,
                Zeile: rowIdx + 1,
                datumStart: employee.start ? moment(employee.start).format('YYYY/MM/DD HH:mm') : null,
                datumEnde: employee.end ? moment(employee.end).format('YYYY/MM/DD HH:mm') : null,
                MitarbeiterID: employee.id ? employee.id : 0,
                NotizElement: employee.note ? employee.note : '',
                ArbeitID: employee.taskId ? employee.taskId : null
              }
              shiftDetailsPayload.push(details)
            })
          })

          const editShiftPayload: EditShiftNewPayload = {
            ProjektSerieID: foundShift.projectSerieId!,
            ProjektID: foundShift.projectId,
            Schichtname: foundShift.shiftName,
            TypeOfShift: foundShift.typeOfShift ? foundShift.typeOfShift : '',
            profitcenter: foundShift.profitcenter,
            SchichtID: foundShift.shiftId,
            Abteilung: foundShift.department,
            Sachbearbeiter: foundShift.sachbearbeiter,
            ReferenzTermin: foundShift.referenzTermin,
            Montag: (periodicity.weekDayList.includes(1)) ? 'true' : 'false',
            Dienstag: (periodicity.weekDayList.includes(2)) ? 'true' : 'false',
            Mittwoch: (periodicity.weekDayList.includes(3)) ? 'true' : 'false',
            Donnerstag: (periodicity.weekDayList.includes(4)) ? 'true' : 'false',
            Freitag: (periodicity.weekDayList.includes(5)) ? 'true' : 'false',
            Samstag: (periodicity.weekDayList.includes(6)) ? 'true' : 'false',
            Sonntag: (periodicity.weekDayList.includes(7)) ? 'true' : 'false',
            Whlg: periodicity.repeatEveryNthWeek.toString(),
            Einmalig: periodicity.isUnique ? 'true' : 'false',
            EndAfternTimes: periodicity.expireAfterRepetitions.toString(),
            EndAfterDate: periodicity.expireAfterDate ?  moment(periodicity.expireAfterDate).format('YYYY/MM/DD HH:mm') : null,
            provisorisch: provisorich,
            fixiert: fixed,
            datumStart: dateStart ? moment(dateStart).format('YYYY/MM/DD HH:mm') : null,
            datumEnde: dateEnd ? moment(dateEnd).format('YYYY/MM/DD HH:mm') : null,
            Adresse: foundShift.address,
            ReferenzProjektID: foundShift.referenzProjektId,
            AbonnementID: foundShift.abonnementId,
            DetailsForUpdate: shiftDetailsPayload,
            ZusatzfelderForUpdate: additionalFieldsPayload
          }

          const response = await this.$store.dispatch(UPDATE_AUTO_SHIFT_PLAN, editShiftPayload)
          if (response && !response.IsError) {
            let updatedIdList: number[] = []

            this.$emit('shiftPlanEdited', editShiftPayload.ProjektSerieID, updatedIdList)
          } else {
            this.$emit('shiftPlanEditedFalse')
          }

        } else if (this.action === ActionsEnum.CREATE) {
          if (!this.$store.getters[PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID]) {
            // Free shift create

            const filterValue: CompanyFilterValue = this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
            const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
            const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
            const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
            const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
            const shiftTemplate: ShiftTemplate | undefined = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM]
            const additionalFields: AdditionalFieldsPayloadItem[] = this.$store.getters[PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS]
            const plannedEmployeeList: PlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]

            const newShiftPayload: CreateShiftPayload = planningService.composeCreateNewShiftPayload(
              filterValue!.profitCenter!.id,
              filterValue!.department!.id,
              this.$store.state.currentUser!.id,
              this.$store.state.selectedUiLanguage!.syzId,
              dateStart,
              dateEnd,
              periodicity,
              availability,
              shiftTemplate,
             this.selectedAddress ? this.selectedAddress.id : null,
             this.selectedProject ? this.selectedProject.id : null,
              this.selectedAbo ? this.selectedAbo.id : null,
              additionalFields,
              plannedEmployeeList
            )

            const newShiftData: CreateShiftNewResponse = await this.$store.dispatch(CREATE_SHIFT_NEW, { newShiftPayload: newShiftPayload })

            if (newShiftData && newShiftData.ProjectSeriesId) {
              this.$emit('newPlanCreated', newShiftData.ProjectSeriesId)
            }

          } else {
            // Free shift periodicity create

            let projectId: number = this.$store.getters[PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID]
            const data: Array<EditShiftPlan> = await this.$store.dispatch(FETCH_EDIT_SHIFT, projectId)
            const foundShift: EditShiftPlan | undefined = data[0]

            const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
            const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
            const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
            const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
            const periodicityPlannedEmployeeList: PeriodicityPlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
            const additionalFieldsPayload: AdditionalFieldsPayloadItem[] = this.$store.getters[PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS]
            let shiftDetailsPayload: EditShiftDetails[] = []
            let planningDetails: PlanningDetailsPayload[] = []

            let fixed: string = ''
            let provisorich: string = ''
            if (availability === ShiftAvailability.Fixed) {
              fixed = 'True'
              provisorich = 'False'
            } else {
              fixed = 'False'
              provisorich = 'True'
            }

            periodicityPlannedEmployeeList.forEach((item: PeriodicityPlannedEmployee) => {
              item.employeeList.forEach((employee: PlannedEmployee, rowIdx: number) => {
                if(employee.detailID) {
                  const details: EditShiftDetails = {
                    detailID: employee.detailID!,
                    Zeile: rowIdx + 1,
                    datumStart: employee.start ? moment(employee.start).format('YYYY/MM/DD HH:mm') : null,
                    datumEnde: employee.end ? moment(employee.end).format('YYYY/MM/DD HH:mm') : null,
                    MitarbeiterID: employee.id ? employee.id : 0,
                    NotizElement: employee.note ? employee.note : '',
                    ArbeitID: employee.taskId ? employee.taskId : null
                  }
                  shiftDetailsPayload.push(details)
                } else {
                  const details: PlanningDetailsPayload = {
                    SchichtID: foundShift.shiftId,
                    ProjektSerie: foundShift.projectSerieId!,
                    datumStart:  moment(employee.start, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
                    datumEnde :moment(employee.end, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
                    MitarbeiterID: employee.id && employee.id || null,
                    NotizElement: employee.note || '',
                    ArbeitID: employee.taskId ? employee.taskId : null,
                    fixiert: false,
                    number: rowIdx + 1,
                    Abteilung: foundShift.department,
                    Zeile: rowIdx + 1,
                    Projekt: item.projectId ? item.projectId : undefined
                  }
                  planningDetails.push(details)
                }
              })
            })

            const editShiftPayload: EditShiftNewPayload = {
              ProjektSerieID: foundShift.projectSerieId!,
              ProjektID: foundShift.projectId,
              Schichtname: foundShift.shiftName,
              TypeOfShift: foundShift.typeOfShift ? foundShift.typeOfShift : '',
              profitcenter: foundShift.profitcenter,
              SchichtID: foundShift.shiftId,
              Abteilung: foundShift.department,
              Sachbearbeiter: foundShift.sachbearbeiter,
              ReferenzTermin: foundShift.referenzTermin,
              Montag: (periodicity.weekDayList.includes(1)) ? 'true' : 'false',
              Dienstag: (periodicity.weekDayList.includes(2)) ? 'true' : 'false',
              Mittwoch: (periodicity.weekDayList.includes(3)) ? 'true' : 'false',
              Donnerstag: (periodicity.weekDayList.includes(4)) ? 'true' : 'false',
              Freitag: (periodicity.weekDayList.includes(5)) ? 'true' : 'false',
              Samstag: (periodicity.weekDayList.includes(6)) ? 'true' : 'false',
              Sonntag: (periodicity.weekDayList.includes(7)) ? 'true' : 'false',
              Whlg: periodicity.repeatEveryNthWeek.toString(),
              Einmalig: periodicity.isUnique ? 'true' : 'false',
              EndAfternTimes: periodicity.expireAfterRepetitions.toString(),
              EndAfterDate: periodicity.expireAfterDate ?  moment(periodicity.expireAfterDate).format('YYYY/MM/DD HH:mm') : null,
              provisorisch: provisorich,
              fixiert: fixed,
              datumStart: dateStart ? moment(dateStart).format('YYYY/MM/DD HH:mm') : null,
              datumEnde: dateEnd ? moment(dateEnd).format('YYYY/MM/DD HH:mm') : null,
              Adresse: foundShift.address,
              ReferenzProjektID: foundShift.referenzProjektId,
              AbonnementID: foundShift.abonnementId,
              DetailsForUpdate: shiftDetailsPayload,
              ZusatzfelderForUpdate: additionalFieldsPayload,
              PlanningDetails: planningDetails
            }

            const response = await this.$store.dispatch(UPDATE_SHIFT_PLAN, editShiftPayload)
            if (response && !response.IsError) {

              let updatedIdList: number[] = []

              this.$emit('shiftPlanEdited', editShiftPayload.ProjektSerieID, updatedIdList)
            } else {
              this.$emit('shiftPlanEditedFalse')
            }
          }

        } else if (this.action === ActionsEnum.EDIT && this.editShift) {
          // Edit

          const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
          const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
          const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
          const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
          const plannedEmployeeList: PlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
          const periodicityPlannedEmployeeList: PeriodicityPlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
          const additionalFieldsPayload: AdditionalFieldsPayloadItem[] = this.$store.getters[PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS]
          let shiftDetailsPayload: EditShiftDetails[] = []
          let planningDetails: PlanningDetailsPayload[] = []

          let fixed: string = ''
          let provisorich: string = ''
          if (availability === ShiftAvailability.Fixed) {
            fixed = 'True'
            provisorich = 'False'
          } else {
            fixed = 'False'
            provisorich = 'True'
          }

          if (this.isEdittingShift) {
            // Edit dialog Project
            const noUpdatedDetails: ShiftEmployeeDetails[] = this.editShift.details.filter((item: ShiftEmployeeDetails) => item.projectId === this.projectId && item.detailId !== this.selectedDetailId)

            noUpdatedDetails.forEach((item: ShiftEmployeeDetails) => {
              const details: EditShiftDetails = {
                detailID: item.detailId!,
                Zeile: item.row,
                datumStart: item.dateStart ? moment(item.dateStart).format('YYYY/MM/DD HH:mm') : null,
                datumEnde: item.dateEnd ? moment(item.dateEnd).format('YYYY/MM/DD HH:mm') : null,
                MitarbeiterID: item.employeeId ? item.employeeId : 0,
                NotizElement: item.note ? item.note : '',
                ArbeitID: item.taskId ? item.taskId : null
              }
              shiftDetailsPayload.push(details)
            })

            plannedEmployeeList.forEach((item: PlannedEmployee) => {
              const details: EditShiftDetails = {
                detailID: this.selectedDetailId,
                Zeile: item.number!,
                datumStart: item.start ? moment(item.start).format('YYYY/MM/DD HH:mm') : null,
                datumEnde: item.end ? moment(item.end).format('YYYY/MM/DD HH:mm') : null,
                MitarbeiterID: item.id ? item.id : 0,
                NotizElement: item.note ? item.note : '',
                ArbeitID: item.taskId ? item.taskId : null
              }
              shiftDetailsPayload.push(details)
            })

          } else if (this.isEdittingSerie) {
            // Edit dialog Serie

            periodicityPlannedEmployeeList.forEach((item: PeriodicityPlannedEmployee) => {
              item.employeeList.forEach((employee: PlannedEmployee, rowIdx: number) => {
                if(employee.detailID) {
                  const details: EditShiftDetails = {
                    detailID: employee.detailID!,
                    Zeile: rowIdx + 1,
                    datumStart: employee.start ? moment(employee.start).format('YYYY/MM/DD HH:mm') : null,
                    datumEnde: employee.end ? moment(employee.end).format('YYYY/MM/DD HH:mm') : null,
                    MitarbeiterID: employee.id ? employee.id : 0,
                    NotizElement: employee.note ? employee.note : '',
                    ArbeitID: employee.taskId ? employee.taskId : null
                  }
                  shiftDetailsPayload.push(details)
                } else {
                  const details: PlanningDetailsPayload = {
                    SchichtID: this.editShift!.shiftId,
                    ProjektSerie: this.editShift!.projectSerieId!,
                    datumStart:  moment(employee.start, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
                    datumEnde :moment(employee.end, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
                    MitarbeiterID: employee.id && employee.id || null,
                    NotizElement: employee.note || '',
                    ArbeitID: employee.taskId ? employee.taskId : null,
                    fixiert: false,
                    number: rowIdx + 1,
                    Abteilung: this.editShift!.department,
                    Zeile: rowIdx + 1,
                    Projekt: item.projectId ? item.projectId : undefined
                  }
                  planningDetails.push(details)
                }
              })
            })

          } else {
            // Edit fast planning

            plannedEmployeeList.forEach((item: PlannedEmployee, rowIdx: number) => {
              const foundDetails: any = this.editShift!.details.find((i: any) => i.row == item.number)
              if(foundDetails && foundDetails.detailId) {
                const details: EditShiftDetails = {
                  detailID: foundDetails.detailId ? foundDetails.detailId : null,
                  Zeile: rowIdx + 1,
                  datumStart: item.start ? moment(item.start).format('YYYY/MM/DD HH:mm') : null,
                  datumEnde: item.end ? moment(item.end).format('YYYY/MM/DD HH:mm') : null,
                  MitarbeiterID: item.id ? item.id : 0,
                  NotizElement: item.note ? item.note : '',
                  ArbeitID: item.taskId ? item.taskId : null
                }
                shiftDetailsPayload.push(details)
              } else {
                const details: PlanningDetailsPayload = {
                  SchichtID: this.editShift!.shiftId,
                  ProjektSerie: this.editShift!.projectSerieId!,
                  datumStart:  moment(item.start, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
                  datumEnde :moment(item.end, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
                  MitarbeiterID: item.id && item.id || null,
                  NotizElement: item.note || '',
                  ArbeitID: item.taskId ? item.taskId : null,
                  fixiert: false,
                  number: rowIdx + 1,
                  Abteilung: this.editShift!.department,
                  Zeile: rowIdx + 1,
                  Projekt: this.editShift!.projectId ? this.editShift!.projectId : undefined
                }
                planningDetails.push(details)
              }
            })
          }

          const editShiftPayload: EditShiftNewPayload = {
            ProjektSerieID: this.editShift.projectSerieId!,
            ProjektID: this.editShift.projectId,
            Schichtname: this.editShift.shiftName,
            TypeOfShift: this.editShift.typeOfShift ? this.editShift.typeOfShift : '',
            profitcenter: this.editShift.profitcenter,
            SchichtID: this.editShift.shiftId,
            Abteilung: this.editShift.department,
            Sachbearbeiter: this.editShift.sachbearbeiter,
            ReferenzTermin: this.editShift.referenzTermin ? moment(this.editShift.referenzTermin).format('YYYY/MM/DD HH:mm') : null,
            Montag: (periodicity.weekDayList.includes(1)) ? 'true' : 'false',
            Dienstag: (periodicity.weekDayList.includes(2)) ? 'true' : 'false',
            Mittwoch: (periodicity.weekDayList.includes(3)) ? 'true' : 'false',
            Donnerstag: (periodicity.weekDayList.includes(4)) ? 'true' : 'false',
            Freitag: (periodicity.weekDayList.includes(5)) ? 'true' : 'false',
            Samstag: (periodicity.weekDayList.includes(6)) ? 'true' : 'false',
            Sonntag: (periodicity.weekDayList.includes(7)) ? 'true' : 'false',
            Whlg: periodicity.repeatEveryNthWeek.toString(),
            Einmalig: periodicity.isUnique ? 'true' : 'false',
            EndAfternTimes: periodicity.expireAfterRepetitions.toString(),
            EndAfterDate: periodicity.expireAfterDate ? moment(periodicity.expireAfterDate).format('YYYY/MM/DD HH:mm') : null,
            provisorisch: provisorich,
            fixiert: fixed,
            datumStart: dateStart ? moment(dateStart).format('YYYY/MM/DD HH:mm') : null,
            datumEnde: dateEnd ? moment(dateEnd).format('YYYY/MM/DD HH:mm') : null,
            Adresse: this.editShift.address,
            ReferenzProjektID: this.selectedProject ? this.selectedProject.id : null,
            AbonnementID: this.selectedAbo ? this.selectedAbo.id : null,
            DetailsForUpdate: shiftDetailsPayload,
            ZusatzfelderForUpdate: additionalFieldsPayload,
            PlanningDetails: planningDetails
          }

          if (this.isEdittingShift) {
            editShiftPayload.ProjektID = this.projectId
            const response = await this.$store.dispatch(UPDATE_SHIFT_PROJECT, editShiftPayload)
            if (response && !response.IsError) {

              let updatedIdList: number[] = []
              this.editShift.details.forEach((item: ShiftEmployeeDetails) => {
                /*if(response.ProjectSeries[0]) {
                  const foundItem: ShiftDetailResponseItem | undefined = response.ProjectSeries[0].details.find((i: ShiftDetailResponseItem) => i.detailID === item.detailId)
                  if (!foundItem) {
                    updatedIdList.push(item.detailId!)
                  }
                } else {
                  updatedIdList.push(item.detailId!)
                }*/
                updatedIdList.push(item.detailId!)
              })

              this.$emit('shiftPlanEdited', editShiftPayload.ProjektSerieID, updatedIdList)
            } else {
              this.$emit('shiftPlanEditedFalse')
            }
          } else {
            const response = await this.$store.dispatch(UPDATE_SHIFT_PLAN, editShiftPayload)
            if (response && !response.IsError) {

              let updatedIdList: number[] = []
              this.editShift.details.forEach((item: ShiftEmployeeDetails) => {
                /*if(response.ProjectSeries[0]) {
                  const foundItem: ShiftDetailResponseItem | undefined = response.ProjectSeries[0].details.find((i: ShiftDetailResponseItem) => i.detailID === item.detailId)
                  if (!foundItem) {
                    updatedIdList.push(item.detailId!)
                  }
                } else {
                  updatedIdList.push(item.detailId!)
                }*/
                updatedIdList.push(item.detailId!)
              })

              this.$emit('shiftPlanEdited', editShiftPayload.ProjektSerieID, updatedIdList)
            } else {
              this.$emit('shiftPlanEditedFalse')
            }
          }
        }
      } finally {
        this.loading = false
      }

    },

    async onCancelButtonClick (): Promise<void> {
      const projectSerieId = this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID]
      const freePeriodicityProjectSerieId = this.$store.getters[PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID]
      if (projectSerieId) {
        await this.$store.dispatch(DELETE_PROJECT_SERIEN, projectSerieId)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID, undefined)
        this.updateDataSet()
      }

      if (freePeriodicityProjectSerieId) {
        await this.$store.dispatch(DELETE_PROJECT_SERIEN, freePeriodicityProjectSerieId)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID, undefined)
        this.updateDataSet()
      }

      this.$emit('close')
    },

    async onEmployeeStepClick (): Promise<void> {
      const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
      const employeeIdList: Array<number> = availableEmployeeList.map((i: EmployeeAvailableForPlanning) => {
        return i.id
      })

      if(this.employeeCapacityList.length === 0) {
        this.employeeCapacityList = await this.fetchCapacityList(employeeIdList)
      }

      const employeeForPlanningList: EmployeeAvailableForPlanning[] = availableEmployeeList.map((item: EmployeeAvailableForPlanning) => {
        const foundEmployee: EmployeeCapacity | undefined = this.employeeCapacityList.find((employee: EmployeeCapacity) => employee.id === item.id)
        const employee: EmployeeAvailableForPlanning = item.updateCapacity (foundEmployee ? foundEmployee.capacity : item.capacity)
        return employee
      })

      this.$store.dispatch(PLANNING_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING, employeeForPlanningList)
    },

    async fetchCapacityList (employeeIdList: Array<number>): Promise<Array<EmployeeCapacity>> {

      const payload: EmployeeCapacityPayload = {
        employeeIdList: employeeIdList,
        calendarDate: moment(this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]).format('DD/MM/YYYY'),
        view: ViewEnum.Month
      }

      return await this.$store.dispatch(FETCH_CAPACITY_LIST, payload)
    },

    async fetchPreSelectedEmployee (item: number): Promise<void> {
      try {
        const response: AutomaticOneResponse = await this.$store.dispatch(FETCH_PRESELECTED_EMPLOYEE, item)
        if(!response.IsError && response.Data && response.Data.Mitarbeiter) {
          const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
          const foundEmployee: EmployeeAvailableForPlanning | undefined = availableEmployeeList.find((item: EmployeeAvailableForPlanning) => item.id === response.Data.Mitarbeiter)
          if(foundEmployee) {
            const selectedEmployee: PlannedEmployee = new PlannedEmployee(
                foundEmployee.id,
                foundEmployee.name,
                foundEmployee.capacity,
                foundEmployee.isFloater,
                foundEmployee.competenceName,
                '',
                this.dateStart,
                this.dateEnd,
                foundEmployee.planingGroupName,
                undefined,
                undefined,
                undefined,
                undefined
            )

            this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, [selectedEmployee])
          }
        }
      } catch {

      }
    }
  },

  beforeMount (): void {
    const payload: ShiftEditorPlanningPayload = this.planningPayload

    this.$store.dispatch(PLANNING_ASSISTANT_RESET_STATE)
    this.$store.dispatch(PLANNING_ASSISTANT_INIT_FROM_PAYLOAD, payload)
  },

  async mounted (): Promise<void> {
    if (this.companyFilter.department) {
      const payload: FetchEmployeeListForPlanningPayload = { departmentId: this.companyFilter.department.id }

      // noinspection JSIgnoredPromiseFromCall
      this.fetchInitialData()

      const filteredEmployeesByDepartment: Array<Employee> = this.filteredEmployees.filter((item: Employee) => item.department === this.companyFilter.department!.id)
      this.$store.dispatch(PLANNING_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT, filteredEmployeesByDepartment)

      const availableEmployeeForPlanning: EmployeeAvailableForPlanning[] = await this.$store.dispatch(FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING, payload)
      const employeeForPlanningList = _.intersectionBy(availableEmployeeForPlanning, this.filteredEmployees, 'id')
      this.$store.dispatch(PLANNING_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING, employeeForPlanningList)

      if (this.initialEmployeeList.length) {
        const plannedEmployeeList: PlannedEmployee[] = this.initialEmployeeList
          .filter((initialEmployeeItem: Employee) => {
            return _.find(employeeForPlanningList, { id: initialEmployeeItem.id })
          })
          .map((initialEmployeeItem: Employee) => {
            const plannableEmployeeItem: EmployeeAvailableForPlanning = _.find(employeeForPlanningList, { id: initialEmployeeItem.id }) as EmployeeAvailableForPlanning

            return new PlannedEmployee(
              plannableEmployeeItem.id,
              plannableEmployeeItem.name,
              plannableEmployeeItem.capacity,
              plannableEmployeeItem.isFloater,
              plannableEmployeeItem.competenceName,
              '',
              this.dateStart,
              this.dateEnd,
              plannableEmployeeItem.planingGroupName,
              undefined,
              undefined,
              undefined,
              undefined
            )
          })

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
      }

      if(this.action === ActionsEnum.CREATE) {
        const securityData = this.$store.getters[GET_SECURITY_DATA]
        const filteredData = securityData.filter((item: SecurityData) => item.area === 'planning')
        const userId = this.$store.state.currentUser.id
        const user: Employee | undefined = this.companyStructure.employeeList.find((item: Employee) => userId === item.id)
        if (user) {
          const foundProfitCenterData: ProfitCenter | undefined = this.companyStructure.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id)
          if (filteredData.find((item: SecurityData) => (item.component === 'selectbox-adress')).visibility && foundProfitCenterData && foundProfitCenterData.addressId) {
            this.fetchPreSelectedEmployee(foundProfitCenterData.addressId)
          }
        }
      }

    }
    if (this.action === ActionsEnum.EDIT && this.isEdittingShift) {
      // Edit project
      this.isEditProject = true
      let availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
      const foundEmployee: any = _.find(this.editShift!.details, { 'detailId': this.selectedDetailId })
      const availableEmployee: EmployeeAvailableForPlanning[] = availableEmployeeList.filter((item: EmployeeAvailableForPlanning) => item.id === foundEmployee.employeeId)
      const employees: Array<EmployeeEvent> = this.employeeEventList
        .filter((item: EmployeeEvent) => item.projectSerieId === this.editShift!.projectSerieId)
      this.selectedEmployeeList = availableEmployee
        .filter((item: EmployeeAvailableForPlanning) => {
          return _.find(employees, { 'employeeId': item.id })
        }).map((i: EmployeeAvailableForPlanning): PlannedEmployee => {
          const employee: any = _.find(this.editShift!.details, { 'detailId': this.selectedDetailId })
          const task: Task = this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST]
            .find((item: Task) => item.id === employee.taskId)
          return new PlannedEmployee(
            i.id,
            i.name,
            i.capacity,
            i.isFloater,
              foundEmployee.competenceName ? foundEmployee.competenceName : '',
              foundEmployee.educationName ? foundEmployee.educationName: '',
            new Date(employee.dateStart),
            new Date(employee.dateEnd),
            i.planingGroupName,
            task ? task.name : undefined,
            employee.note ? employee.note : undefined,
            employee.taskId ? employee.taskId : undefined,
            employee.row ? employee.row : undefined
          )
        })
      this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, this.selectedEmployeeList)
      if (this.editShift && this.editShift.fixed === 'True') {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Fixed)
      } else {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Temporary)
      }

      const filteredAdditionalFields: AdditionalGroup[] = this.editShift!.additionalFields.filter((item: AdditionalGroup) => item.project === this.projectId)
      this.$store.dispatch(PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST, filteredAdditionalFields)

    } else if (this.action === ActionsEnum.EDIT && this.isEdittingSerie) {
      // Edit serie

      this.$store.dispatch(PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE, true)
      const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]

      this.selectedEmployeeList = this.editShift!.details
        .map((detail: ShiftEmployeeDetails): PlannedEmployee => {
          const task: Task = this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST]
            .find((item: Task) => item.id === detail.taskId)
          const employee: EmployeeAvailableForPlanning | undefined = availableEmployeeList.find((employee: EmployeeAvailableForPlanning) => employee.id === detail.employeeId)
          const planningGroup: PlanningGroup | undefined = this.companyStructure.planningGroupList.find((i: PlanningGroup) => detail.planningGroup === i.planningGroup)
          return new PlannedEmployee(
            employee ? employee.id : undefined,
            employee ? employee!.name : '',
            employee ? employee!.capacity : undefined,
            employee ? employee!.isFloater : false,
              detail.competenceName ? detail.competenceName : '',
              detail.educationName ? detail.educationName: '',
            new Date(detail.dateStart),
            new Date(detail.dateEnd),
            planningGroup ? planningGroup.planningGroupName : undefined,
            task ? task.name : undefined,
            detail.note ? detail.note : undefined,
            detail.taskId ? detail.taskId : undefined,
            detail.row ? detail.row : undefined,
            detail.detailId ? detail.detailId : undefined,
              detail.projectId ? detail.projectId : undefined
          )
        })

      let data: PeriodicityPlannedEmployee[] = []
      this.selectedEmployeeList.forEach((item: PlannedEmployee) => {
        let foundItem: PeriodicityPlannedEmployee | undefined

        if (data.length > 0) {
          foundItem = data.find((i: PeriodicityPlannedEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
        }

        if (foundItem) {
          foundItem.employeeList.push(item)
        } else {
          data.push({ date: moment(item.start).format('DD.MM.YYYY'), projectId: item.projectId ? item.projectId : null, employeeList: [item] })
        }
      })

      data = _.sortBy(data, [function (o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD') }])

      this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)
      if (this.editShift && this.editShift.fixed === 'True') {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Fixed)
      } else {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Temporary)
      }

      this.$store.dispatch(PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST, this.editShift!.additionalFields)

    } else if (this.action === ActionsEnum.EDIT) {
      // Edit normal

      const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
      const employees: Array<EmployeeEvent> = this.employeeEventList
        .filter((item: EmployeeEvent) => item.projectSerieId === this.editShift!.projectSerieId)
      this.selectedEmployeeList = availableEmployeeList
        .filter((item: EmployeeAvailableForPlanning) => {
          return _.find(employees, { 'employeeId': item.id })
        }).map((i: EmployeeAvailableForPlanning): PlannedEmployee => {
          const employee: any = _.find(this.editShift!.details, { 'employeeId': i.id })
          const task: Task = this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST]
            .find((item: Task) => item.id === employee.taskId)
          return new PlannedEmployee(
            i.id,
            i.name,
            i.capacity,
            i.isFloater,
              employee.competenceName ? employee.competenceName : '',
              employee.educationName ? employee.educationName: '',
            new Date(employee.dateStart),
            new Date(employee.dateEnd),
            i.planingGroupName ? i.planingGroupName : undefined,
            task ? task.name : undefined,
            employee.note ? employee.note : undefined,
            employee.taskId ? employee.taskId : undefined,
            employee.row ? employee.row : undefined,
            employee.detailId ? employee.detailId : undefined
          )
        })

      if(this.editShift && this.editShift.shiftId) {
        this.editShift!.details.filter((item: ShiftEmployeeDetails) => item.employeeId === 0).forEach((i: ShiftEmployeeDetails) => {
          const task: Task = this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST].find((item: Task) => item.id === i.taskId)
          this.selectedEmployeeList.push(
              new PlannedEmployee(
                  undefined,
                  'Avatar',
                  undefined,
                  false,
                  i.competenceName ? i.competenceName : '',
                  i.educationName ? i.educationName : '',
                  new Date(i.dateStart),
                  new Date(i.dateEnd),
                  undefined,
                  task ? task.name : undefined,
                  i.note ? i.note : undefined,
                  i.taskId ? i.taskId : undefined,
                  i.row ? i.row : undefined,
                  i.detailId ? i.detailId : undefined
              )
          )
        })
      }

      this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, this.selectedEmployeeList)
      if (this.editShift && this.editShift.fixed === 'True') {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Fixed)
      } else {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Temporary)
      }

      this.$store.dispatch(PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST, this.editShift!.additionalFields)
    }
  }
})
